function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    "data-name": "Layer 1",
    viewBox: "0 0 595.28 534.89"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M522.47 267.45c0 59.01-23.92 112.41-62.58 151.08-32.33 32.33-74.99 54.35-122.6 60.69-9.32 1.25-18.82 1.89-28.47 1.89-13.14 0-26.01-1.19-38.49-3.46C170.7 459.53 95.17 372.32 95.17 267.46c0-59.01 23.92-112.42 62.58-151.08 38.67-38.67 92.08-62.58 151.08-62.58 117.99 0 213.66 95.66 213.66 213.66Z",
    style: {
      fill: "#00333e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.29 260.13c-2.88 22.06-5.6 43.25-8.4 64.63l-54.62.02c0 21.08.02 117.68.02 154.44-9.32 1.25-18.82 1.89-28.47 1.89-13.14 0-26.01-1.19-38.49-3.46V324.52h-54.8l-.02-64.34h55.13c.31-22.76-1.4-45.79 2.04-68.34 11.15-65.66 75.92-67.81 129.45-60.46l.02 57.62c-77.57-4-63.53 10.07-65.31 71.14 3.04.02 48.02 0 63.46 0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }));
};
export default SvgFacebook;